// Static marketing content for the pricing page (plans/addons come from /api/plans)
export const PLAN_ORDER = ["free", "basic", "pro", "business"];

export const COMPARISON = [
  { label: "Oferte AI pe lună", values: { free: "3", basic: "30", pro: "150", business: "Nelimitat" } },
  { label: "Generare PDF", values: { free: true, basic: true, pro: true, business: true } },
  { label: "Logo & branding firmă", values: { free: false, basic: true, pro: true, business: true } },
  { label: "Generare text cu AI", values: { free: false, basic: true, pro: true, business: true } },
  { label: "Istoric oferte", values: { free: false, basic: true, pro: true, business: true } },
  { label: "AI Project Manager", values: { free: false, basic: "Add-on", pro: true, business: true } },
  { label: "Materiale & consumabile", values: { free: false, basic: false, pro: true, business: true } },
  { label: "Muncitori & echipamente", values: { free: false, basic: false, pro: true, business: true } },
  { label: "Urmărire costuri & profit", values: { free: false, basic: false, pro: true, business: true } },
  { label: "Alerte & recomandări AI", values: { free: false, basic: false, pro: true, business: true } },
  { label: "Monitorizare buget & progres", values: { free: false, basic: false, pro: true, business: true } },
  { label: "Export Excel & PDF avansat", values: { free: false, basic: false, pro: false, business: true } },
  { label: "Utilizatori incluși", values: { free: "1", basic: "1", pro: "1", business: "5" } },
  { label: "White Label & panou admin", values: { free: false, basic: false, pro: false, business: true } },
  { label: "Suport", values: { free: "Email", basic: "Email", pro: "Prioritar", business: "Prioritar" } },
];

export const TRUST = [
  { icon: "shield", text: "Plăți securizate prin Stripe" },
  { icon: "x", text: "Anulezi oricând, fără penalizări" },
  { icon: "card", text: "Fără card pentru planul gratuit" },
  { icon: "globe", text: "Date găzduite în UE" },
];

export const TESTIMONIALS = [
  {
    quote: "Făceam oferte în Excel ore întregi. Acum trimit o ofertă profesională în 5 minute, cu PDF și logo-ul firmei.",
    name: "Andrei M.",
    role: "Firmă de amenajări interioare, Cluj",
  },
  {
    quote: "AI Project Manager mi-a arătat că pierdeam bani pe o lucrare. Acum urmăresc materialele și manopera pe fiecare proiect.",
    name: "Vasile P.",
    role: "Antreprenor construcții, Brașov",
  },
  {
    quote: "Alertele AI și reamintirile automate au crescut rata de acceptare a ofertelor. Recomand oricărui meseriaș serios.",
    name: "Ionuț D.",
    role: "Instalații sanitare & termice, București",
  },
];

export const FAQS = [
  {
    q: "Pot schimba planul oricând?",
    a: "Da. Poți face upgrade sau downgrade oricând din pagina Abonament. La upgrade beneficiezi imediat de noile funcții.",
  },
  {
    q: "Ce este AI Project Manager?",
    a: "Este modulul premium care îți gestionează lucrările acceptate: materiale, muncitori, consumabile, costuri, progres, plus alerte și recomandări AI. Inclus în Pro și Business, disponibil ca add-on pentru Basic.",
  },
  {
    q: "Cum funcționează facturarea anuală?",
    a: "Plătești pentru 12 luni în avans și economisești 20% față de plata lunară. Poți reveni la lunar la următoarea reînnoire.",
  },
  {
    q: "Pot anula oricând?",
    a: "Da. Anulezi din pagina Abonament și beneficiezi de plan până la finalul perioadei deja plătite.",
  },
  {
    q: "Ce metode de plată acceptați?",
    a: "Acceptăm card bancar (Visa, Mastercard) prin Stripe, procesator de plăți securizat la nivel mondial.",
  },
  {
    q: "Planul gratuit necesită card?",
    a: "Nu. Începi gratuit, fără card, cu 3 oferte AI pe lună. Adaugi un card doar când treci la un plan plătit.",
  },
];
